import { ReduxActionTypes } from "constants/ReduxActionConstants";
import { AccountApiResponse } from "types/ApiResponseTypes";
import { createAction } from "utils/ActionUtils";

export const fetchAccountDetails = () =>
  createAction(ReduxActionTypes.FETCH_ACCOUNT_DETAILS);

export const updateAccountDetails = (val: AccountApiResponse) =>
  createAction(ReduxActionTypes.FETCH_ACCOUNT_DETAILS_SUCCESS, val);
